import { downloader } from "../common/DownloadForm/downloader";
import { DataTicketUpdate } from "../../models/ticket.model";
import { NAMES_ES } from "../../assets/appConstants/constants";
import { DownloadIcon } from "../common/Icons";
import './index.css'
import { TableColumn } from "../../models/dataTable.model";


const TableSchema: TableColumn[] = [
  { key: 'number', name: NAMES_ES.number, width: '10%' },
  { key: 'date', name: NAMES_ES.date, width: '15%' },
  { key: 'status_name', name: NAMES_ES.status, width: '10%' },
  { key: 'priority_name', name: NAMES_ES.priority, width: '10%' },
  { key: 'company_name', name: NAMES_ES.company, width: '20%' },
  { key: 'updated_by', name: NAMES_ES.updated_by, width: '20%' },
  { key: 'attachment', name: NAMES_ES.attachment, width: '15%' },
]

const columnId: string = 'number'

const rowDataPreprocesor = (rowData: DataTicketUpdate): DataTicketUpdate => {

  return {
    ...rowData,
    updated_by: typeof rowData.updated_by === "object" ? rowData.updated_by.label : rowData.updated_by,
    attachment: ((rowData.attachment) && (<DownloadIcon className="download-attachment-icon"
      onClick={() => rowData.attachment && downloader(rowData.attachment)}
    />))
  }
}

const handleDoubleClickRow = (project_code: string, ticket_number: string, update_nbr: string, navigate: any) => {
  navigate(`/${project_code}/ticket/update/view/${ticket_number}/${update_nbr}`)
}

export { TableSchema, columnId, rowDataPreprocesor, handleDoubleClickRow }